import { atom } from "recoil"

export const outboxContactsRequestIdState = atom({
  key: "atoms/contact/outboxContactsRequestIdState",
  default: 0,
})
